/** Library menu for the librarian portal. */

export const LIBRARIAN_LIBRARY_NAV = [
    {
        to: "/Teacher/library",
        label: "Library & TLMs",
        hint: "Inventory, borrowing register, and stock reports",
        match: (p) => p.startsWith("/Teacher/library"),
    },
];
